<app-hero-image
  [title]="'Environmental'"
  [imageUrl]="
    environment.cloudFrontUrl + '/content/environmental/Environmental_1.jpg'
  "
></app-hero-image>
<div class="page-content-container">
  <h2 style="margin-top: 0">I-24 Southeast Choice NEPA Process</h2>
  <p>
    TDOT is developing an Environmental Assessment (EA) to evaluate any
    potential impacts the proposed I-24 Southeast Choice Lanes project would
    have on the natural and built environments as required by the National
    Environmental Policy Act (NEPA).
  </p>

  <div class="pdf-grid">
    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[0].url"
      [title]="pdfDocuments[0].title"
      [thumbnailUrl]="pdfDocuments[0].thumbnail"
      containerId="adobe-dc-view-1"
    ></app-pdf-viewer>
    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[4].url"
      [title]="pdfDocuments[4].title"
      [thumbnailUrl]="pdfDocuments[4].thumbnail"
      containerId="adobe-dc-view-5"
    ></app-pdf-viewer>
  </div>

  <p>
    Through the NEPA process, TDOT is required to conduct extensive
    environmental studies to document the existing environmental and community
    resources in the area and identify opportunities to avoid or minimize
    impacts to those resources. NEPA also requires TDOT to share updates with
    the public and collect feedback on environmental studies and potential
    design options, known as “alternatives.” This virtual meeting serves as a
    platform so you can be informed and have a say in the future of Choice
    Lanes!
  </p>

  <p>
    The Project Team has been in the field collecting information and drafting
    reports so we can understand everything from noise levels to the animal and
    plant species that live in the area. The team also examined community
    facilities, historic and cultural sites and air quality. This information
    will help our Project Team understand existing conditions in the corridor
    today and evaluate potential impacts as we develop alternatives for the
    future Choice Lanes. Check out the materials linked below to understand more
    about the environmental review process, NEPA and more.
  </p>

  <div class="pdf-grid">
    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[1].url"
      [title]="pdfDocuments[1].title"
      [thumbnailUrl]="pdfDocuments[1].thumbnail"
      containerId="adobe-dc-view-2"
    ></app-pdf-viewer>

    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[2].url"
      [title]="pdfDocuments[2].title"
      [thumbnailUrl]="pdfDocuments[2].thumbnail"
      containerId="adobe-dc-view-3"
    ></app-pdf-viewer>

    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[5].url"
      [title]="pdfDocuments[5].title"
      [thumbnailUrl]="pdfDocuments[5].thumbnail"
      containerId="adobe-dc-view-6"
    ></app-pdf-viewer>

    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[3].url"
      [title]="pdfDocuments[3].title"
      [thumbnailUrl]="pdfDocuments[3].thumbnail"
      containerId="adobe-dc-view-4"
    ></app-pdf-viewer>
  </div>
</div>
